import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { Store } from "../Store";
import MessageBox from "./MessageBox";

export default function ProtectedRoute({ children }) {
  const { state } = useContext(Store);
  const { userInfo } = state;

  if (userInfo && userInfo.isHelpDesk && !userInfo.client) {
    return (
      <div style={{ marginTop: "100px" }}>
        <MessageBox variant="info">
          Lütfen bir işletme ile bağlantı kurun!
        </MessageBox>
      </div>
    );
  }

  return userInfo && (userInfo.isUser || userInfo.isAdmin) ? (
    children
  ) : userInfo && userInfo.isCustomer ? (
    <Navigate to="/qrmenu" />
  ) : (
    <Navigate to="/signin" />
  );
}
